/**
 * List role
 */
export const ROLE_EMPLOYEE_BRANCH_STAFF = 'BranchStaff';
export const ROLE_EMPLOYEE_DIRECTOR = 'Director';
export const ROLE_EMPLOYEE_MANAGER = 'Manager';
export const ROLE_EMPLOYEE_TEACHER = 'Teacher';
export const ROLE_EMPLOYEE_COORDINATOR = 'Coordinator';
export const ROLE_EMPLOYEE_MENTOR = 'Mentor';
export const ROLE_EMPLOYEE_BRANCH_HEAD = 'BranchHead';

export const ROLE_STUDENT = 'Student';
export const ROLE_ADMINISTRATOR = 'Admin';

export const employeeRoles = [
    {id: ROLE_EMPLOYEE_BRANCH_STAFF, name: 'Staf Cabang'},
    {id: ROLE_EMPLOYEE_DIRECTOR, name: 'Direktur'},
    {id: ROLE_EMPLOYEE_MANAGER, name: 'Manajer'},
    {id: ROLE_EMPLOYEE_TEACHER, name: 'Pengajar'},
    {id: ROLE_EMPLOYEE_COORDINATOR, name: 'Korbid'},
    {id: ROLE_EMPLOYEE_MENTOR, name: 'Binglas'},
    {id: ROLE_EMPLOYEE_BRANCH_HEAD, name: 'Kepala Cabang'}
];

export const additionalRoles = [{id: ROLE_STUDENT, name: 'Siswa'}, {id: ROLE_ADMINISTRATOR, name: 'Administrator'}];

export const tinyMCEOptions = {
    external_plugins: {
        eqneditor: '/static/vendor/tinymce/plugins/eqneditor/plugin.min.js'
    },
    content_css: [
        '/static/vendor/tinymce/css/main.css?timestamp=' + (new Date).getTime()
    ],
    toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | eqneditor | image | removeformat',
    plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample eqneditor'
    ],
    image_caption: true,
    image_advtab: true,
    convert_urls: false,
    file_picker_types: 'image',
    file_picker_callback: function (callback) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.style.visibility = 'hidden';
        input.style.position = 'absolute';

        input.onchange = function () {
            var file = this.files[0];
            if (file) {
                var reader = new FileReader();
                reader.onload = function (event) {
                    callback(event.target.result, {alt: file.name});
                };
                reader.readAsDataURL(file);
            }
        };
        input.click();
    }

};

export const semesters = [
    {id: 1, name: "Semester 1"},
    {id: 2, name: "Semester 2"},
    {id: 3, name: "Intensif UTBK"},
    {id: 4, name: "Intensif Mandiri"}
];


// WEBPACK FOOTER //
// ./src/params.js